import { observer } from "mobx-react";
import * as React from "react";
import { Redirect, Route } from "react-router-dom";
import { CustomSwitch } from "../../app/router/CustomSwitch";
import { Routes } from "../../app/router/Routes";
import { DataUploadSite } from "../sites/DataUploadSite";
import { DetailsSite } from "../sites/DetailsSite";
import { MotivationSite } from "../sites/MotivationSite";
import { PersonalDataSite } from "../sites/PersonalDataSite";
import { SuccessSite } from "../sites/SuccessSite";
import { VerificationSite } from "../sites/VerificationSite";
import { ApplicationRoutes } from "./ApplicationRoutes";

export const ApplicationRouter = observer(() => (
    <CustomSwitch>
        <Route path={ApplicationRoutes.PERSONAL_DATA} component={PersonalDataSite} />
        <Route path={ApplicationRoutes.DETAILS} component={DetailsSite} />
        <Route path={ApplicationRoutes.DATA_UPLOAD} component={DataUploadSite} />
        <Route path={ApplicationRoutes.MOTIVATION} component={MotivationSite} />
        <Route path={ApplicationRoutes.VERIFICATION} component={VerificationSite} />
        <Route path={ApplicationRoutes.SUCCESS} component={SuccessSite} />

        <Route exact path={Routes.APPLICATION}>
            <Redirect to={ApplicationRoutes.PERSONAL_DATA} />
        </Route>
    </CustomSwitch>
));
